import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const globalHeaderDefaultVariants = {}
const globalHeaderCompoundVariants = []

const globalHeaderSlotNames = [
  [
    "headerLayout",
    "global_header__headerLayout"
  ],
  [
    "logoLayout",
    "global_header__logoLayout"
  ],
  [
    "zenidLogo",
    "global_header__zenidLogo"
  ],
  [
    "kadokawaGroupLogo",
    "global_header__kadokawaGroupLogo"
  ]
]
const globalHeaderSlotFns = /* @__PURE__ */ globalHeaderSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, globalHeaderDefaultVariants, getSlotCompoundVariant(globalHeaderCompoundVariants, slotName))])

const globalHeaderFn = memo((props = {}) => {
  return Object.fromEntries(globalHeaderSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const globalHeaderVariantKeys = []
const getVariantProps = (variants) => ({ ...globalHeaderDefaultVariants, ...compact(variants) })

export const globalHeader = /* @__PURE__ */ Object.assign(globalHeaderFn, {
  __recipe__: false,
  __name__: 'globalHeader',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: globalHeaderVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, globalHeaderVariantKeys)
  },
  getVariantProps
})